module.exports = __webpack_public_path__ + "static/pendant-landing-fe23f08455f50e7406eb6cae0950e128.jpg";